import React, { Fragment, useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectIsLoading,
  makeSelectDimensions,
  makeSelectMetricTotal,
  makeSelectShowHistory,
  makeSelectSwitchMoreDimensions,
  makeSelectMeasureInfo,
  makeSelectDivisions,
  makeSelectIsLoadingGraphicBars,
  makeSelectGraphicBars,
  makeSelectMeasureRangeColor,
  makeSelectTeam,
  makeSelectGraphicTeamPeakon,
  makeSelectIsLoadingGraphicTeamPeakon,
  makeSelectQuestions,
  makeSelectIfFirst,
  makeSelectShowVariation,
  makeSelectEvolutionData,
  makeSelectEvolutionLines
} from "./selectors"
import {
  getDimensionsWatcher,
  getDivisionsWatcher,
  getHistoryByTeamWatcher,
  getMeasureColorRangeWatcher,
  graphicBarsWatcher,
} from "./actions"

import "./index.less"
import { Empty, Layout, Spin, Radio } from "antd"
import { Helmet } from "react-helmet"
import BlockFreemiumPageBlur from "../../../components/BlockFreemiumPageBlur"
import { isModuleBySlug, LOCAL_ACTIVE_ROL } from "../../../utils/storage"
import { HISTORICAL_ANALYSIS, ROLE_LEADER } from "../../../utils/constants"
import { validate } from "../../../utils/functions"
import EmptyStateAnonymity from "../../../components/EmptyStateAnonymity"
import { get } from "lodash"
import ResultByDimensionV2 from "../../../components/ResultByDimensionV2"
import MeasurementColorRange from "../../../components/MeasurementColorRange"
import HeaderDimension from "../../../components/HeaderDimension"
import ContentTopDimension from "../../../components/ContentTopDimension"
import emptyImg from "images/emptyStateDimension.svg"
import { loadTexts } from "../../../utils/i18n"
import ResultByQuestion from "../../../components/ResultByQuestion"
import { verifyFeatureFlag } from "../../../utils/feature-flags"

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function usePreviousDivisionID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function DimensionByTeam(props) {
  const intlDimensionByTeam = loadTexts("reports_team_analysis_view")
    .dimensionByTeam
  const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()
  const searchLocation = getUrlParams(location.search) || {}
  const [measureID] = useState(parseInt(props.match.params.id))
  const [divisionID] = useState(props.match.params.idDivision)

  const prevMeasureID = usePreviousMeasureID(measureID)
  const prevDivisionID = usePreviousDivisionID(divisionID)
  const [selectedDivision, setSelectedDivision] = useState(null)
  const [isHistoricalAnalysis] = useState(isModuleBySlug(HISTORICAL_ANALYSIS))
  const [selectedTableView, setSelectedTableView] = useState("dimensions")

  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    } else {
      if (prevDivisionID !== divisionID) {
        initGetData()
      }
    }

    if ( searchLocation.id_segment !== undefined && searchLocation.id_segment !== null ) {
      localStorage.setItem("id_segment", searchLocation.id_segment)
    } else{
      localStorage.removeItem("id_segment");
    }
  }, [props.match.params.id, props.match.params.idDivision])

  useEffect(() => {
    loadDetails()
  }, [props.match.params.idDivision])

  const initGetData = async () => {
    const {
      graphicBarsWatcher,
      getMeasureColorRangeWatcher,
      getHistoryByTeamWatcher,
      getDivisions,
    } = props
    const searchLocation = getUrlParams(location.search)
    const leaderSelected = window.location.pathname.split('/')[5]

    let paramsPath = { ...searchLocation }

    if (leaderSelected == 'all'){
      graphicBarsWatcher({
        idMeasure: measureID,
        switchBars: isHistoricalAnalysis ? 1 : 0,
        id_segment: paramsPath.id_segment,
      })
    }
    getDivisions({ idMeasure: measureID, id_segment: paramsPath.id_segment })
    getMeasureColorRangeWatcher({
      measure: measureID,
      id_segment: paramsPath.id_segment,
    })

    setSelectedDivision(divisionID)
  }

  const loadDetails = () => {
    const { getDimensions, getHistoryByTeamWatcher, graphicBarsWatcher } = props
    const searchLocation = getUrlParams(location.search)
    const leaderSelected = window.location.pathname.split('/')[5]
    let paramsPath = { ...searchLocation }

    getDimensions({
      idDivision:
        props.match.params.idDivision !== "all"
          ? props.match.params.idDivision
          : null,
      idMeasure: measureID,
      id_segment: paramsPath.id_segment,
    })

    if (leaderSelected != 'all'){
      getHistoryByTeamWatcher({
        idMeasure: measureID,
        idDivision: leaderSelected,
        id_segment: paramsPath.id_segment,
      })
    } else {
      graphicBarsWatcher({
        idMeasure: measureID,
        switchBars: isHistoricalAnalysis ? 1 : 0,
        id_segment: paramsPath.id_segment,
      })
    }
  }

  const renderHeader = () => {
    const { measureInfo, divisions } = props
    if (!Array.isArray(divisions)) {
      return null
    }
    let selectedDivisionInfo = null
    if (validate.exist(selectedDivision)) {
      selectedDivisionInfo = props.divisions.find(
        (item) => item.id == selectedDivision
      )
    }
    return (
      <HeaderDimension
        measureInfo={measureInfo}
        selectedDivisionInfo={selectedDivisionInfo}
        leaders={divisions}
        changeDivision={changeDivision}
        searchLocation={searchLocation}
      />
    )
  }

  const changeDivision = (value) => {
    setSelectedDivision(value)

    const stringParamSegment = localStorage.getItem("id_segment") ? `&id_segment=${localStorage.getItem("id_segment")}` : ""

    const extraParams = value != null && isUserLeader ? "" : `?home=true${stringParamSegment}`
    props.history.push(
      `/reports/measure/${measureID}/teams/${value || "all"}/dimensions` + extraParams
    )
  }

  const renderContent = () => {
    const selectedDivisionName = props.divisions.find(
      (item) => item.id == selectedDivision
    )

    const anonymityValidate =
      validate.exist(selectedDivision) && selectedDivision !== "all"
        ? !get(selectedDivisionName, "anonymity_check.valid", false)
        : false

    if (anonymityValidate) {
      return (
        <Empty
          style={{ color: "#828282" }}
          image={emptyImg}
          description={
            <span
              style={{
                margin: "0 auto 30px",
                maxWidth: 440,
                display: "block",
              }}>
              Aún no se cuenta con <b>resultados</b> por dimensión porque no se
              cumple el anonimato pactado.
            </span>
          }
          className="ReportsHome-empty-fix"
        />
      )
    }
    return (
      <div className="DimensionByTeam-Content">
        {renderContentTop()}
        {renderContentBottom()}
      </div>
    )
  }

  const renderContentTop = () => {
    const {
      divisions,
      metricTotal,
      measureInfo,
      switchMoreDimensions,
      showHistory,
      match,
      graphicBarsWatcher,
      isLoadingGraphicBars,
      graphicBars,
      isLoadingGraphicByTeamPeakon,
      historyByTeam,
      team,
      evolutionData,
      evolutionLines,
    } = props


    if (
      parseInt(searchLocation.id_segment) === 0 &&
      get(props.measureInfo, "segments", []).length > 0
    ) {
      return null
    }
    let selectedDivisionInfo = null
    if (validate.exist(selectedDivision)) {
      selectedDivisionInfo = props.divisions.find(
        (item) => item.id == selectedDivision
      )
    }
    return (
      <ContentTopDimension
        team={team || []}
        divisions={divisions || []}
        metricTotal={metricTotal}
        match={match}
        selectedDivision={selectedDivision}
        measureInfo={measureInfo}
        selectedDivisionInfo={selectedDivisionInfo}
        switchMoreDimensions={switchMoreDimensions}
        showHistory={showHistory}
        isLoadingGraphicBars={isLoadingGraphicBars}
        graphicBars={graphicBars}
        graphicBarsWatcher={graphicBarsWatcher}
        isLoadingGraphicPeakon={isLoadingGraphicByTeamPeakon}
        historyByDivision={historyByTeam}
        hasLeader
        evolutionData={evolutionData}
        evolutionLines={evolutionLines}
      />
    )
  }

  const renderContentBottom = () => {
    const {
      divisions,
      dimensions,
      measureInfo,
      showHistory,
      measureColorRange,
      isLoading,
      questionList,
      ifFirst,
      showVariation
    } = props
    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px",
            paddingRight: "4px",
          }}>
            {verifyFeatureFlag('lip') && <div>
              <span style={{
                fontWeight: 600,
                fontSize: "13px",
                lineHeight: "17px",
                marginRight: "8px",
              }}>
                {intlDimensionByTeam.displayBy}
              </span>
              <Radio.Group
              options={[{label: intlDimensionByTeam.dimensions, value: 'dimensions'}, {label: intlDimensionByTeam.questions, value:'questions'}]}
              value={selectedTableView}
              optionType="button"
              onChange={(e) => {setSelectedTableView(e.target.value)}}
              />
            </div>}
          <div style={{ width: "max-content" }}>
            <MeasurementColorRange measureColorRange={measureColorRange} />
          </div>
        </div>
        {selectedTableView === 'dimensions' && <ResultByDimensionV2
          divisions={divisions}
          measureInfo={measureInfo}
          measureColorRange={measureColorRange}
          showHistory={showHistory}
          showVariation={showVariation}
          ifFirst={ifFirst}
          data={dimensions}
          isLoading={isLoading}
          isExpandable
        />}
        {selectedTableView === 'questions' &&
        <ResultByQuestion
          data={questionList}
          measureInfo={measureInfo}
          measureColorRange={measureColorRange}
          showHistory={showHistory}
          showVariation={showVariation}
          ifFirst={ifFirst}
          isLoading={isLoading}
        />
        }
      </Fragment>
    )
  }

  if (props.isLoading) {
    return (
      <Fragment>
        <div className="DimensionByTeam loadingSpin">
          <Spin size="large" />
        </div>
      </Fragment>
    )
  }

  return (
    <Layout>
      <Helmet>
        <title>{intlDimensionByTeam.titlePage}</title>
        <meta name="description" content="Description of DimensionByTeam" />
      </Helmet>
      <div className="DimensionByTeam">
        <div className="DimensionByTeam-Container">
          {renderHeader()}
          {renderContent()}
        </div>
      </div>
      <BlockFreemiumPageBlur view="engagement-result-dimension" />
    </Layout>
  )
}

DimensionByTeam.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
  isLoading: PropTypes.bool,
  divisions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  dimensions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  metricTotal: PropTypes.object,
  team: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  graphicBars: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isLoadingGraphicBars: PropTypes.bool,
  historyByTeam: PropTypes.object,
  isLoadingGraphicByTeamPeakon: PropTypes.bool,
  switchMoreDimensions: PropTypes.bool,
  showHistory: PropTypes.bool,
  ifFirst: PropTypes.bool,
  showVariation: PropTypes.bool,
  measureColorRange: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureInfo: PropTypes.object,
  graphicBarsWatcher: PropTypes.func,
  getMeasureColorRangeWatcher: PropTypes.func,
  getHistoryByTeamWatcher: PropTypes.func,
  getDivisions: PropTypes.func,
  getDimensions: PropTypes.func,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  dimensions: makeSelectDimensions(),
  divisions: makeSelectDivisions(),
  metricTotal: makeSelectMetricTotal(),
  team: makeSelectTeam(),
  graphicBars: makeSelectGraphicBars(),
  isLoadingGraphicBars: makeSelectIsLoadingGraphicBars(),
  historyByTeam: makeSelectGraphicTeamPeakon(),
  isLoadingGraphicByTeamPeakon: makeSelectIsLoadingGraphicTeamPeakon(),
  switchMoreDimensions: makeSelectSwitchMoreDimensions(),
  showHistory: makeSelectShowHistory(),
  showVariation: makeSelectShowVariation(),
  ifFirst: makeSelectIfFirst(),
  measureColorRange: makeSelectMeasureRangeColor(),
  measureInfo: makeSelectMeasureInfo(),
  questionList: makeSelectQuestions(),
  evolutionData: makeSelectEvolutionData(),
  evolutionLines: makeSelectEvolutionLines()
})

function mapDispatchToProps(dispatch) {
  return {
    graphicBarsWatcher: (params) => dispatch(graphicBarsWatcher(params)),
    getMeasureColorRangeWatcher: (params) =>
      dispatch(getMeasureColorRangeWatcher(params)),
    getHistoryByTeamWatcher: (params) =>
      dispatch(getHistoryByTeamWatcher(params)),
    getDivisions: (params) => dispatch(getDivisionsWatcher(params)),
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "dimensionByTeam", reducer })
const withSaga = injectSaga({ key: "dimensionByTeam", saga })

export default compose(withReducer, withSaga, withConnect)(DimensionByTeam)
